<template lang="pug">
    div.row.info.p-a.no-gutter(v-if="hasSelected")
        div.col-sm-3.form-inline
            div.form-group
                input.form-control(
                    type="text",
                    placeholder="Search...",
                    :value="tableInstance.query",
                    @keyup="search($event)"
                )
        
        ul.nav.pull-right
            li.nav-item.inline.p-r-md
                a.nav-link(
                    @click="clearSelected"
                )
                    i.material-icons.md-18.m-r-sm &#xe5cd;
                span.selected-count {{ totalSelected }} selected

            li.nav-item.inline
                a.btn.btn-outline.b-white.text-white(
                    @click="checkboxActions.callback"
                ) {{ checkboxActions.title }}
</template>

<script>
import mixins from '../mixins';
const debounce = require('debounce');

export default {
    mixins: [mixins],

    computed: {
        checkboxActions() {
            // fix old settings compatibility - delete only
            if (!_.isEmpty(this.propOptions.checkbox)) {
                const text =
                    'Are you sure to permanently delete the selected items?';
                const title = this.propOptions.checkbox.delete_title;

                return {
                    title,
                    callback: () => {
                        const options = {
                            text,
                            title,
                            type: 'warning',
                            confirmButtonColor: '#d33',
                            confirmText: 'Yes, delete it',
                            url: this.propOptions.checkbox.api_delete,
                            method: 'post',
                            params: {
                                ids: this.getSelected,
                            },
                            onSuccess: () => {
                                this.tableInstance.getData();
                                this.clearSelected();
                            },
                        };

                        this.swalAjaxConfirmation(options);
                    },
                };
            } else {
                // might have few actions instead of delete
            }
        },
    },

    methods: {
        search: _.debounce(function(event) {
            const search = this.tableInstance.serverSearch(
                event,
                this.tableInstance,
            );
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/plugins/vuetable2-checkbox/components/header-action.vue